import dayjs from "dayjs";

export const calculateTimeProgress = (plan) => {
  const now = dayjs();
  const created = dayjs(plan.created_at);
  
  if (!plan.deadline) {
    // Si no hay deadline, usar 90 días por defecto
    const defaultDeadline = created.add(90, 'day');
    const daysLeft = defaultDeadline.diff(now, 'day');
    const progress = Math.max(0, Math.min(100, ((90 - daysLeft) / 90) * 100));
    
    return {
      daysLeft: Math.max(0, daysLeft),
      totalDays: 90,
      progress
    };
  }
  
  const deadline = dayjs(plan.deadline);
  const totalDays = deadline.diff(created, 'day');
  const daysLeft = deadline.diff(now, 'day');
  
  // Calcular el progreso como porcentaje
  const progress = Math.max(0, Math.min(100, ((totalDays - daysLeft) / totalDays) * 100));
  
  return {
    daysLeft: Math.max(0, daysLeft),
    totalDays,
    progress
  };
};